import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import logo from '../../img/logo-horizontal-positive.svg';
import styles from './footer.module.scss';

export function Footer() {

    const { t } = useTranslation();

    return (
        <footer className={styles.footerContainer}>
            <img className={styles.footerLogo} alt="s" src={logo} />
            <div className={styles.footerLinkImprint}><Link className={styles.contextFontGreatL} to="/imprint">{t('deTranslation.footerImprint.linkText')}</Link></div>
            <div className={styles.footerLinkData}><Link className={styles.contextFontGreatL} to="/dataprotection">{t('deTranslation.footerDataProtection.linkText')}</Link></div>
            <div className={styles.footerLinkContact}><Link className={styles.contextFontGreatL} to="/contact">{t('deTranslation.footerContact.linkText')}</Link></div>
        </footer>
    );
}

export default Footer;
